export enum RequestStatusSlugs {
   draft = 'draft',
   pending = 'pending',
   approved = 'approved',
   rejected = 'rejected',
   cancelled = 'cancelled',
}

export enum ReviewerStatusSlugs {
   pending = 'pending',
   approved = 'approved',
   rejected = 'rejected',
}

export enum ReviewerRoleSlugs {
   required = 'required',
   optional = 'optional',
}
